import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import Swatch from '../../swatch-group/swatch'
import SwatchGroup from '../../swatch-group'

const SingleColorSwatch = ({swatchData, styles}) => {
    // count is additional colors (total − 1); 0 = single color → no swatch.
    if (!swatchData?.count) {
        return null
    }

    const {count, swatchURL} = swatchData

    return (
        <Flex {...styles.swatchRow}>
            <SwatchGroup ariaLabel="Colors">
                <Swatch
                    key="main-color"
                    value="color"
                    name="Color"
                    isProductTile
                    variant="circle"
                    circleStyles={{width: 3, height: 3, minWidth: 3, padding: 0}}
                    {...styles.swatchItem}
                >
                    <Box
                        {...styles.swatchImage}
                        backgroundImage={`url(${swatchURL})`}
                    />
                </Swatch>
            </SwatchGroup>
            {count > 0 && (
                <Text {...styles.swatchCount}>
                    +{count}
                </Text>
            )}
        </Flex>
    )
}

SingleColorSwatch.propTypes = {
    styles: PropTypes.object,
    swatchData: PropTypes.shape({
        count: PropTypes.number,
        swatchURL: PropTypes.string
    })
}

export default SingleColorSwatch
